import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider, useAuth } from '@/contexts/AuthContext'
import { QueryProvider } from '@/providers/QueryProvider'
import { ErrorBoundary } from '@/components/ErrorBoundary'
import { ProtectedRoute } from '@/components/ProtectedRoute'
import { AppLayout } from '@/components/layout/AppLayout'
import { AuthSplash } from '@/components/layout/AuthSplash'
import { Login } from '@/pages/Login'
import { Dashboard } from '@/pages/Dashboard'
import { Toaster } from 'sonner'

function LoginRoute() {
  const { user, loading } = useAuth()
  // While Firebase resolves the initial session, show the neutral splash (same as ProtectedRoute)
  // instead of the login form — otherwise an already-signed-in visitor refreshing here would see
  // the sign-in page for a beat before being redirected to the portal.
  if (loading) return <AuthSplash />
  // Once Firebase confirms a session, leave login. ProtectedRoute shows the dashboard
  // skeleton (or NotAuthorized) while risk-assessment access is resolved.
  if (user) return <Navigate to="/" replace />
  return <Login />
}

function App() {
  return (
    <ErrorBoundary>
      <Router>
        <QueryProvider>
          <AuthProvider>
            <Routes>
              <Route path="/login" element={<LoginRoute />} />
              <Route path="/dashboard" element={<Navigate to="/" replace />} />

              <Route element={<ProtectedRoute />}>
                <Route element={<AppLayout />}>
                  <Route path="/" element={<Dashboard />} />
                </Route>
              </Route>

              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>

            <Toaster
              position="top-center"
              toastOptions={{
                classNames: {
                  toast:
                    '!bg-white !text-foreground !border !border-border/60 !shadow-[0_2px_16px_rgba(0,0,0,0.08)] !rounded-xl',
                  title: '!text-sm !font-medium',
                  description: '!text-xs !text-muted-foreground',
                  success: '[&_[data-icon]]:!text-foreground/70',
                  error: '[&_[data-icon]]:!text-destructive',
                },
              }}
            />
          </AuthProvider>
        </QueryProvider>
      </Router>
    </ErrorBoundary>
  )
}

export default App
